
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { TUTORIALS } from "@/utils/constants";

@Component
export default class Tutorials extends Vue {
  @Getter private isMobile: boolean;
  private TUTORIALS = TUTORIALS;
}
